// extracted by mini-css-extract-plugin
export default {"Container":"J5qjoGvQ","Image":"qk0vMZV4"};